"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRenderByAuth = exports.cleanObj = void 0;
exports.slugify = slugify;
const constants_1 = require("./constants");
function slugify(str = '') {
    let toSlugify;
    toSlugify = str.replace(/^\s+|\s+$/g, '');
    toSlugify = toSlugify.toLowerCase();
    const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
    const to = 'aaaaeeeeiiiioooouuuunc------';
    for (let i = 0, l = from.length; i < l; i++) {
        toSlugify = toSlugify.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
    toSlugify = toSlugify
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    return toSlugify;
}
const cleanObj = (obj) => Object.fromEntries(Object.entries(obj).filter(([, v]) => typeof v != 'undefined'));
exports.cleanObj = cleanObj;
const shouldRenderByAuth = (authenticationState, isOpenDoor) => {
    if (authenticationState === constants_1.AuthenticationState.AUTHENTICATED && isOpenDoor)
        return false;
    if (authenticationState === constants_1.AuthenticationState.ANONYMOUS && !isOpenDoor)
        return false;
    return true;
};
exports.shouldRenderByAuth = shouldRenderByAuth;
